import Checkbox from '@components/Checkbox';
import Column from '@components/Column';
import RadioButton from '@components/RadioButton';
import Text from '@components/Text';
import TextField from '@components/TextField';
import { useAtomValue } from 'jotai';
import { Fragment, useState } from 'react';

import styles from './styles.module.scss';
import { paymentMethodAtom } from '../../atoms/paymentAtoms';

function CashReceipt() {
  const [value, setValue] = useState<string>('none');
  const method = useAtomValue(paymentMethodAtom);
  if (method === 'prepay') {
    return (
          <Column spacing={8}
                  fullWidth
                  className={styles.container}>
              <div className={styles.title}>
                  <Text size='lg' fontWeight='bold'>현금영수증</Text>
              </div>
              <RadioButton value={value}
                           onChange={setValue}
                           options={[
                             { value: 'none', label: '신청안함' },
                             { value: 'private', label: '개인소득공제용' },
                             { value: 'business', label: '사업자증빙용' },
                           ]}/>
              <TextField placeholder='휴대전화번호 10~11자리'/>
              <Checkbox>현금영수증 발급번호 저장</Checkbox>
          </Column>
    );
  }
  return <Fragment/>;
}

export default CashReceipt;
